<template functional>
  <div
    :class="{ preferred: props.preferred }"
    class="purchase-option-tile-component"
  >
    <p class="tile-label">
      {{ props.label }}
    </p>
    <p class="tile-price">
      {{ props.price }}
    </p>
    <button
      class="tile-action"
      :disabled="props.disabled"
      @click="listeners['tile-clicked']"
    >
      {{ props.buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PurchaseTile',
  props: {
    buttonText: {
      type: String,
      default: 'Buy Now',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    price: {
      type: String,
    },
    preferred: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-option-tile-component {
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: rem-calc(14);
  box-shadow: 0px 2px 16px 0 rgba(0, 0, 0, 0.1);
  width: rem-calc(180);
  height: rem-calc(230);
  padding: rem-calc(20);
  display: flex;
  flex-direction: column;
  justify-content: space-between;


  .tile-label,
  .tile-price {
    margin: 0;
  }

  .tile-label {
    color: #767676;
    font-size: 1rem;
    font-weight: $semi-bold;
    letter-spacing: 0.17px;
    text-align: center;
    text-transform: uppercase;
  }

  .tile-price {
    font-size: rem-calc(40);
    font-weight: $semi-bold;
    text-align: center;
  }

  .tile-action {
    background: transparent;
    border-radius: 24px;
    border: solid 2px #8d0098;
    color: #8d0098;
    font-size: rem-calc(20);
    font-weight: $semi-bold;
    height: rem-calc(48);
    letter-spacing: 1.67px;
    text-transform: uppercase;

    &:disabled {
      opacity: .3;
      cursor: not-allowed;
    }

  }

  &.preferred {
    .tile-action {
      background-color: #8d0098;
      color: #ffffff;
    }
  }

  @include breakpoint(small) {
    height: rem-calc(160);
    padding: rem-calc(16) rem-calc(8);
    width: 30%;

    .tile-label {
      font-size: rem-calc(12);
    }

    .tile-price {
      font-size: rem-calc(24);
    }

    .tile-action {
      font-size: rem-calc(14);
      height: rem-calc(32);
      margin: 0 auto;
      max-width: 80%;
      width: 100%;
    }
  }
 }
</style>
